import { NgModule } from '@angular/core';
import { OAuthCallbackComponent } from './oauth-callback.component';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
// import { OAuthCallbackHandler } from './oauth-callback.guard';
@NgModule({
  imports: [CommonModule, RouterModule],
  declarations: [OAuthCallbackComponent],
  //providers: [/*OAuthCallbackHandler*/]
})
export class OAuthHandshakeModule { } 